import axios from "axios";
import {
  getHeader,
  handleResponse,
  handleGoResponse,
  getApiUrl,
  getGoApiUrl,
} from "./http.header";

const getHandleAllResponse = (url) => {
  if (url.indexOf("panel/") > -1) {
    return handleGoResponse;
  }
  return handleResponse;
};

const getActualBaseUrl = (url, baseUrl, version = "v1") => {
  if (url.indexOf("panel/") > -1) {
    baseUrl = getGoApiUrl(null, version);
  } else if (!baseUrl) {
    baseUrl = getApiUrl();
  }
  return baseUrl;
};
export default {
  get(url, exportname, baseUrl, version = "v1") {
    baseUrl = getActualBaseUrl(url, baseUrl, version);
    const handleAllResponse = getHandleAllResponse(url);
    return new Promise((resolve, reject) => {
      var response = axios.get(baseUrl + url, { headers: getHeader() });
      handleAllResponse(response, exportname, (error, data) => {
        if (error) {
          reject(data);
        } else {
          resolve(data);
        }
      });
    });
  },
  post(url, data, exportname, baseUrl, version = "v1") {
    baseUrl = getActualBaseUrl(url, baseUrl, version);
    const handleAllResponse = getHandleAllResponse(url);
    var options = { headers: getHeader() };
    return new Promise((resolve, reject) => {
      var response = axios.post(baseUrl + url, data, options);
      handleAllResponse(response, exportname, (error, data) => {
        if (error) {
          reject(data);
        } else {
          resolve(data);
        }
      });
    });
  },
  patch(url, data, exportname, baseUrl) {
    baseUrl = getActualBaseUrl(url, baseUrl);
    const handleAllResponse = getHandleAllResponse(url);
    var options = { headers: getHeader() };
    return new Promise((resolve, reject) => {
      var response = axios.patch(baseUrl + url, data, options);
      handleAllResponse(response, exportname, (error, data) => {
        if (error) {
          reject(data);
        } else {
          resolve(data);
        }
      });
    });
  },
  put(url, data, baseUrl) {
    baseUrl = getActualBaseUrl(url, baseUrl);
    const handleAllResponse = getHandleAllResponse(url);
    return new Promise((resolve, reject) => {
      const response = axios.put(baseUrl + url, data, { headers: getHeader() });
      handleAllResponse(response, "", (error, data) => {
        if (error) {
          reject(data);
        } else {
          resolve(data);
        }
      });
    });
  },
  deleteRecord(url, baseUrl) {
    //var baseUrl = getApiUrl();
    baseUrl = getActualBaseUrl(url, baseUrl);
    const handleAllResponse = getHandleAllResponse(url);
    var options = { headers: getHeader() };
    return new Promise((resolve, reject) => {
      var response = axios.delete(baseUrl + url, options);
      handleAllResponse(response, "", (error, data) => {
        if (error) {
          reject(data);
        } else {
          resolve(data);
        }
      });
    });
  },
};
